import urlUtils from "@/common/utils/urlUtils";
import type { ExperienceMetadataInit } from "@/types/experience";

export default class ExperienceMetadata {
  // Copied from window.pixmoto.experienceMetadata by Object.assign.
  declare pixmotoUID: ExperienceMetadataInit["pixmotoUID"];
  declare assetServer: ExperienceMetadataInit["assetServer"];
  declare mediaServer: ExperienceMetadataInit["mediaServer"];
  declare apiServer: ExperienceMetadataInit["apiServer"];
  declare sharedServer: ExperienceMetadataInit["sharedServer"];
  declare idexperience: ExperienceMetadataInit["idexperience"];
  declare url: ExperienceMetadataInit["url"];
  declare experienceUrl: ExperienceMetadataInit["experienceUrl"];
  declare ipAddress: ExperienceMetadataInit["ipAddress"];

  constructor(metadata?: ExperienceMetadataInit | null) {
    Object.assign(this, metadata);
  }

  getSharedAssetUrl(filename: string): string {
    if (this.sharedServer === undefined) {
      return "";
    }
    const ret = `${urlUtils.protocol()}//${this.sharedServer}/${filename}`;
    return ret;
  }

  getMerchantFileUrl(filename: string): string {
    return this.getSharedAssetUrl(`common/merchants/${filename}`);
  }

  getAssetUrl(filename: string): string {
    if (this.assetServer === undefined) {
      return "";
    }
    const ret = `${urlUtils.protocol()}//${this.assetServer}/${filename}`;
    return ret;
  }

  getMediaUrl(filename: string): string {
    if (this.mediaServer === undefined) {
      return "";
    }
    const ret = `${urlUtils.protocol()}//${this.mediaServer}/${filename}`;
    return ret;
  }

  getVideoUrl(
    idvideo: unknown,
    mode: string,
    mime: string,
    token: string,
  ): string {
    if (this.apiServer === undefined) {
      return "";
    }
    const ret =
      urlUtils.protocol() +
      "//" +
      this.apiServer +
      "/video/" +
      idvideo +
      "/src" +
      "?mode=" +
      encodeURIComponent(mode) +
      "&mime=" +
      encodeURIComponent(mime) +
      "&token=" +
      encodeURIComponent(token);
    return ret;
  }
}
